import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../storage/store";
import { setCareers } from "../slice/configSlice";

export const useConfigStore = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { careers, items } = useSelector((state: RootState) => state.config);

    const storeCareer = (configData: any) => {
        dispatch(setCareers(configData));
    };

    return {
        careers,
        storeCareer,
        dispatch
    };
}